<template>
  <v-container
    class="ip-signings-view-container"
    fluid
  >
    <h1>Zeichnungbescheinigung Sparplan</h1>
    <ip-signings-table
      :ip-signings="ipSignings"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { IpSigningsTable } from '@/components/ire';

export default {
  name: 'IpSignings',
  components: {
    'ip-signings-table': IpSigningsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.financialProductsStore.loading,
      ipSignings: state => state.ipSigningsStore.ipSignings,
    }),
  },
  mounted() {
    this.getIpSignings();
  },
  methods: {
    ...mapActions(['getIpSignings']),
  },
};
</script>


<style lang="scss" scoped>
.ip-signings-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/ire/IpSignings.vue